export default __webpack_public_path__ + "static/media/Calendar-Icon.d39591e2.png";